import { useMediaQuery } from "@mui/material";
import React from "react";
import { theme } from "@/theme";
import { Carousel } from "@/components/carousel";

export type CleanSectionProps = {
  mobileTitle?: string;
  desktopTitle?: string;
  bgImage?: string;
  sectionCards?: {
    icon?: string;
    title?: string;
    description?: string;
  }[];
};

export const CleanSection = ({
  mobileTitle,
  desktopTitle,
  bgImage,
  sectionCards,
}: CleanSectionProps) => {
  const isSmallScreen = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.lg)
  );

  if (sectionCards === undefined || sectionCards?.length === 0) return null;

  const slides = sectionCards.map((slide, index) => (
    <div
      className="m-w-[295px] xl:m-w-[314px] relative mx-auto lg:flex-grow"
      key={index}
    >
      <svg
        viewBox="0 0 295 327"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.5))" }}
        className="w-full"
      >
        <path
          d="M294.989 196.385C294.989 268.142 228.956 326.318 147.489 326.318C66.0229 326.318 0 268.142 0 196.385C0 124.629 94.823 40.9198 147.5 0.318359C200.177 40.9198 295 124.618 295 196.385H294.989Z"
          fill="white"
        />
      </svg>
      <div className="width-full height-full absolute left-0 top-0 z-[1] px-10 pt-[73px] text-center">
        {slide.icon && (
          <img src={slide.icon} alt={slide.title} loading="lazy" height="60" />
        )}
        {slide.title && (
          <h3 className="font-myriad-pro-condensed mb-1 mt-6 text-3xl font-semibold uppercase leading-[30px] text-primary xl:mb-1 xl:text-[28px] xl:leading-[35px]">
            {slide.title}
          </h3>
        )}
        {slide.description && (
          <p className="text-xs leading-[140%] text-black">
            {slide.description}
          </p>
        )}
      </div>
    </div>
  ));

  const desktopLayout = (
    <div className="mx-auto flex w-full max-w-[1022px] gap-6 xl:gap-10">
      {slides.map((slide) => slide)}
    </div>
  );

  return (
    <div className="relative">
      <div className="page-module relative z-[2] px-0 py-6 lg:px-14 lg:py-8">
        <h2 className="mb-6 text-center text-8xl font-semibold text-primary md:text-6xl md:leading-[70px] lg:mb-12 lg:text-[56px]">
          <span
            className="md:hidden"
            dangerouslySetInnerHTML={{ __html: mobileTitle ?? "" }}
          ></span>
          <span className="hidden md:block">{desktopTitle}</span>
        </h2>
        {isSmallScreen ? (
          <Carousel
            items={slides}
            slidePosition="stretch"
            slideGap={false}
            arrows={"none"}
            breakpoints={{ 768: { slidesPerView: 2 } }}
          />
        ) : (
          desktopLayout
        )}
      </div>
      <img
        src={bgImage}
        alt=""
        role="presentation"
        className="absolute left-0 top-0 z-[1] h-full w-full object-cover object-center"
        loading="lazy"
      />
    </div>
  );
};
